import { FILE_BASE_URL } from "config/apiConfig";

const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;
const FRONTEND_PUBLIC_ASSET_PATTERN = /^\/badge\//;

export const getPublicAssetUrl = (path: string) => {
  if (ABSOLUTE_URL_PATTERN.test(path)) return path;
  if (FRONTEND_PUBLIC_ASSET_PATTERN.test(path)) return path;

  const normalizedPath = path.replace(/^\/+/, "");
  return FILE_BASE_URL
    ? `${FILE_BASE_URL}/${normalizedPath}`
    : `/${normalizedPath}`;
};

export const getBadgePublicAssetUrl = (
  code: string,
  state: "locked" | "unlocked" = "unlocked",
) => `/badge/${state}/${code.toLowerCase()}.png`;

export const formatCount = (value: number) => value.toLocaleString("ja-JP");
